import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalOrderFilterProps } from '@apps-common/stores'
import { ISearchCountModel } from '@apps-common/types/general'

export const QUERY_SEARCH_ORDERS_COUNT = (
  companyId?: string,
  orderNo?: string,
  startDate?: string | null,
  endDate?: string | null,
  status?: string,
  skip?: number,
  take?: number
) => ['searchOrdersCount', companyId, orderNo, startDate, endDate, status].filter(Boolean)

export const searchOrdersCount = async (
  companyId: string,
  orderNo: string,
  startDate: string | null,
  endDate: string | null,
  status: string,
  skip: number,
  take: number
): Promise<ISearchCountModel> =>
  axios
    .get(
      `/Order/OrdersCount?companyId=${companyId}&orderNo=${orderNo}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}&status=${status}&skip=${skip}&take=${take}`
    )
    .then((res) => res.data?.data)

type QueryFnType = typeof searchOrdersCount

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IPortalOrderFilterProps
}

export const useSearchOrdersCount = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_SEARCH_ORDERS_COUNT(
      model.companyId,
      model.orderNo,
      model.startDate,
      model.endDate,
      model.status,
      model.skip,
      model.take
    ),
    queryFn: () => searchOrdersCount(model.companyId, model.orderNo, model.startDate, model.endDate, model.status, model.skip, model.take)
  })
